var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm._.wrapper, _vm.noSafeArea && _vm._.noSafeArea]},[_vm._t("default"),_c('div',{class:[_vm._.holder, 'x-holder'],style:({
      '--bar-height': (_vm.barHeight + "px"),
    })})],2)}
var staticRenderFns = []

export { render, staticRenderFns }